/** @format */

// Labels of the `<typology>_details` fields (verbose_name of the models, 01/11/2026),
// used when OPTIONS gives none (it only describes fields to product managers).
export const DETAILS_LABELS = {
  is_huawei_smartguard: 'Coffret Huawei Smartguard ?',
  only_for_ductable: 'Uniquement pour gainable ?',
  alternating_current_type: 'Type de courant alternatif',
  distributor: 'Gestionnaire de réseau',
  model: 'Modèle',
  range: {
    battery: 'Gamme',
    inverter: "Gamme d'onduleur",
  },
  total_energy: 'Energie totale (kWh)',
  usable_energy: 'Energie utilisable (kWh)',
  capacity: {
    battery: 'Capacité (kWh)',
    hot_water_tank: 'Capacité (L)',
  },
  voltage_range: 'Gamme de tension (V)',
  max_power_charge: {
    battery: 'Puissance maximale de charge (kW)',
    monitoring: 'Puissance de charge max (kW)',
  },
  max_power_discharge: {
    battery: 'Puissance maximale de décharge (kW)',
    monitoring: 'Puissance de décharge max (kW)',
  },
  peak_power: 'Puissance crête (kW)',
  weight: 'Poids (kg)',
  height: 'Hauteur (mm)',
  width: 'Largeur (mm)',
  depth: 'Profondeur (mm)',
  charge_cycle_count: 'Nombre de cycles de charge',
  lifetime: 'Durée de vie',
  voltage: 'Tension (V)',
  technology: 'Technologie',
  power: {
    battery: 'Puissance (kW)',
    heat_pump_aa: 'Puissance (kW)',
    hot_water_tank: 'Puissance PAC (kW)',
  },
  is_battery_module: 'Module de batterie ?',
  guarantee: {
    battery: 'Garantie',
    heat_pump_aa: 'Garantie',
    hot_water_tank: 'Garantie (années)',
    inverter: 'Garantie fabricant',
    monitoring: 'Garantie fabriquant',
    optimiser: 'Garantie fabriquant',
    solar_panel: 'Garantie fabriquant',
    structure: 'Garantie fabriquant',
  },
  register_needed: 'Nécessite un enregistrement ?',
  yearly_degradation: 'Dégradation annuelle (%)',
  is_backup_compatible: 'Compatible backup ?',
  all_brands_compatible: 'Compatible toutes marques ?',
  is_virtual_battery: 'Batterie virtuelle ?',
  monthly_subscription_per_kwc:
    'Abonnement mensuel par kWc batterie virtuelle (€)',
  need_support: 'Besoin de support ?',
  number_of_batteries_per_support: 'Nombre de batteries par support',
  installation_type: "Type d'installation",
  inverter_kind: "Type d'onduleur",
  for_micro_inverter: 'Pour micro-onduleur ?',
  acdc: 'AC/DC',
  max_ac_power: 'Puissance maximum AC (W)',
  max_dc_voltage: 'Tension DC maximale (V)',
  solar_panel_count: 'Nombre de panneaux max',
  mppt_dc_count: 'Nombre de trackers MPPT en courant continu (DC)',
  is_battery_box: 'Est un coffret batterie ?',
  is_backup_box: 'Est un coffret back-up ?',
  is_for_erp: 'Est pour ERP ?',
  split_type: 'Type de split',
  location_type: 'Type de localisation',
  is_for_ductable: 'Pour gainable ?',
  cold_power: 'Puissance froide (kW)',
  hot_power: 'Puissance chaude (kW)',
  cold_energy_efficiency: 'Efficacité énergétique froid',
  hot_energy_efficiency: 'Efficacité énergétique chaud',
  scop: 'SCOP',
  seer: 'SEER',
  extended_guarantee: 'Garantie étendue',
  noise_level: {
    heat_pump_aa: 'Niveau sonore (dB)',
    hot_water_tank: 'Niveau sonore (dB(A))',
  },
  max_interior_split: "Nombre maximum d'unités intérieures",
  gaz_type: 'Type de gaz',
  mounting_type: 'Type de pose',
  energy_efficiency: 'Efficacité énergétique',
  tapping_profile: 'Profil de soutirage',
  water_heating_efficiency: 'Rendement ECS ηwh (%)',
  cop: 'COP',
  cop_air_temperature: "Température de l'air pour le COP (°C)",
  heating_element_power: "Puissance de l'appoint (W)",
  max_refrigerant_line_length: 'Longueur max. liaison frigorifique (m)',
  is_connected: 'Wi-Fi intégré',
  type: {
    inverter: "Type d'onduleur",
    monitoring: 'Type',
    structure: "Type d'installation",
  },
  managed_solar_panel_count: 'Nombre de panneaux par micro-onduleur',
  use_optimiser: 'Fonctionne avec optimiseur ?',
  input_count: "Nombre d'entrées",
  mppt_count: 'Nombre de MPPT',
  max_voltage: 'Tension maximale admissible (V)',
  max_current: 'Intensité maximale admissible (A)',
  has_extension: "Possibilité d'extension",
  extension_duration: 'Durée maximum de la garantie avec extension',
  is_hybrid: 'Onduleur hybride ?',
  min_temperature: 'Température minimale (°C)',
  max_temperature: 'Température maximale (°C)',
  max_ac_power_output: 'Puissance max sortie AC (W)',
  max_dc_power_input: 'Puissance max entrée DC (W)',
  max_continuous_output_current: 'Intensité maximale de sortie continue (A)',
  nominal_dc_input_voltage: "Tension d'entrée DC nominale (V)",
  max_efficiency: {
    inverter: 'Rendement maximal (%)',
    optimiser: 'Efficience maximale (%)',
  },
  nighttime_power_consumption: 'Consommation de nuit (W)',
  efficiency_balance_ue: {
    inverter: 'Rendement pondéré (%)',
    optimiser: "Equilibre d'efficience UE (%)",
  },
  is_integrated_inverter: 'Onduleur intégré ?',
  has_criteria_vat_10: 'A les critères TVA 10% MyLight',
  max_energy: 'Énergie max (kWh)',
  is_monitoring: 'Monitoring ?',
  is_automation: 'Domotique ?',
  consumption_monitoring: 'Suivi de consommation ?',
  resistive_load_control: 'Pilotage charge résistive ?',
  is_contact_sec: 'Contact sec ?',
  is_favorite_monitoring_for_brand: 'Monitoring favori pour la marque ?',
  nominal_input_power: "Puissance d'entrée nominale (W)",
  max_voltage_input: "Tension d'entrée maximale (V)",
  short_circuit_current: {
    optimiser: 'Courant de court-circuit (A)',
    solar_panel: 'Intensité de court-circuit (A)',
  },
  has_criteria_530: 'A les critères 530 / TVA 5,5%',
  cell_type: 'Type de cellule',
  glass_type: 'Type de verre',
  panel_type: 'Type de panneau',
  finish: 'Finition',
  country_origin: "Pays d'origine",
  nominal_power: 'Puissance nominale (Wc)',
  power_tolerance: 'Tolérance de puissance (%)',
  surface_efficiency: 'Rendement (%)',
  climate_resistance_min: 'Résistance climatique minimale (°C)',
  climate_resistance_max: 'Résistance climatique maximale (°C)',
  open_circuit_voltage: 'Tension circuit ouvert (V)',
  temperature_coefficient_pmax: 'Coefficient de température Pmax (%)',
  current_at_mpp: 'Intensité à MPP (A)',
  voltage_at_mpp: 'Tension à MPP (V)',
  years_linear_power_guarantee: 'Garantie de puissance linéaire',
  percentage_linear_power_guarantee:
    'Pourcentage de la garantie de puissance linéaire',
  module_width: 'Largeur (mm)',
  module_length: 'Longueur (mm)',
  module_height: 'Hauteur (mm)',
  annual_degradation: 'Dégradation annuelle (-%)',
  color: 'Couleur',
  performance_guarantee: 'Garantie de performance',
  workforce_guarantee: "Garantie main d'œuvre",
  package_name: 'Nom du package',
  flat_roof_mount_type: 'Type de support pour les toits terrasse',
  tile_type: 'Type de tuile',
  is_default: 'Par défaut ?',
  is_default_for_steelbox: 'Par défaut pour bac acier ?',
  has_integration: 'A une intégration ?',
  under_typology: 'Sous typologie ?',
  related_typology: 'Typologie associée',
  difficulty: 'Difficulté de pose',
  new_pricing_system: 'Nouveau système de prix ?',
  min_kwc: 'Kwc minimum',
  max_kwc: 'Kwc maximum',
  is_for_backup_installation: 'Pour backup ?',
};

export function getDetailsLabel(detailsKey, field) {
  const entry = DETAILS_LABELS[field];
  if (!entry) return field;
  if (typeof entry === 'string') return entry;
  return entry[detailsKey.replace(/_details$/, '')] || Object.values(entry)[0];
}
